import { create } from 'zustand'

import { createSelectors } from '../helpers'

export type QuestViewMode = 'quest' | 'stars'

const DEFAULT_MODE: QuestViewMode = 'quest'

type QuestViewModeState = {
  mode: QuestViewMode
  actions: {
    setMode: (mode: QuestViewMode) => void
  }
}

const useQuestViewModeStoreBase = create<QuestViewModeState>((set) => ({
  mode: DEFAULT_MODE,
  actions: {
    setMode: (mode) => set({ mode }),
  },
}))

export const useQuestViewModeStore = createSelectors(useQuestViewModeStoreBase)

export const useQuestViewModeActions = () =>
  useQuestViewModeStoreBase((state) => state.actions)
